import { useSnackbar } from 'notistack'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { useDeleteCircleBooth } from '~/features/circle-participation/queries/useCircleApply'
import Close from '~/shared/assets/icons/Close'
import Button from '~/shared/components/buttons/Button'
import { isModalOpenState, selectedApplicationIdState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function CircleApplyCancelConfirmModal() {
  const [selectedApplicationId] = useRecoilState(selectedApplicationIdState)
  const [isModalOpen, setIsModalOpen] = useRecoilState(isModalOpenState)

  const { enqueueSnackbar } = useSnackbar()

  const { mutate: deleteCircleBoothMutate } = useDeleteCircleBooth()

  const deleteCircleBooth = () => {
    if (selectedApplicationId) {
      deleteCircleBoothMutate(selectedApplicationId, {
        onSuccess: (res) => {
          if (res.errorCode === -3002) {
            enqueueSnackbar('신청서 삭제에 실패했습니다.', { variant: 'error' })
          } else if (res.errorCode === 0) {
            setIsModalOpen({
              ...isModalOpen,
              contents: 'circle-apply-deleted',
              isOpen: true,
            })
          }
        },
      })
    }
  }

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <CloseIcon
        onClick={() =>
          setIsModalOpen({ ...isModalOpen, contents: '', isOpen: false })
        }
      />

      <MainText>
        서클 부스 신청을 <br /> 취소하시겠습니까?
      </MainText>
      <SubText>
        취소 요청을 하시면, 이후 담당자가 확인하여 처리해 드리겠습니다. <br />
        확인 하는동안 시간이 소요될 수 있습니다.
      </SubText>
      <ButtonBox>
        <Button
          $width={194}
          $height={58}
          $fontSize={24}
          $variant="transparent"
          onClick={deleteCircleBooth}
        >
          취소 신청하기
        </Button>
      </ButtonBox>
    </Wrapper>
  )
}

export default CircleApplyCancelConfirmModal

const Wrapper = styled.section`
  position: fixed;
  z-index: ${theme.zIndex.backdrop};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  box-sizing: border-box;
  min-width: 30%;
  height: auto;
  margin: 0 auto;
  padding: 108px 77px 60px;

  background-color: ${theme.colors.white};
  border-radius: 12px;

  @media ${theme.device.medium} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    overflow-y: scroll;

    width: 90%;
    padding: 56px 20px 30px;
  }
`

const CloseIcon = styled(Close)`
  cursor: pointer;
  position: absolute;
  top: 36px;
  right: 36px;

  @media ${theme.device.medium} {
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
  }
`

const MainText = styled.h1`
  width: ${theme.calculatePcVw(580)};

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 42px;
  font-weight: 500;
  line-height: 140%;
  text-align: center;

  @media ${theme.device.medium} {
    width: 100%;
    height: 100px;

    font-size: 36px;
    font-weight: 500;
    line-height: 140%;
  }
`

const SubText = styled.div`
  width: ${theme.calculatePcVw(580)};

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 140%;
  color: ${theme.colors.grey_5};
  text-align: center;

  @media ${theme.device.medium} {
    width: 100%;
    font-size: 15px;
    font-weight: 400;
    line-height: 140%;
  }
`

const ButtonBox = styled.div`
  display: flex;
  gap: 20px;
  width: ${theme.calculatePcVw(580)};

  > :nth-child(1) {
    width: 100%;
    color: ${theme.colors.white};
    background-color: ${theme.colors.black};
  }

  > :nth-child(2) {
    width: 100%;
    color: ${theme.colors.black};
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.black};
  }

  @media ${theme.device.medium} {
    flex-direction: column;

    > :nth-child(1) {
      width: 50%;
      margin: 0 auto;
    }

    > :nth-child(2) {
      width: 50%;
      margin: 0 auto;
    }
  }
`
